module.exports = __webpack_public_path__ + "static/media/ABN App Over View - GBR Tech - 28-05-2025 C.416ee64d.gif";